type NodeProperty = {
  name: string,
  value: string,
}

export type PortalOptionModel = {
  cache_key: number,
  id: number,
  node_name: string,
  node_properties?: NodeProperty[],
  portal_id: number,
  title: string,
}

export type PortalOptionRequestOptions = {
  include_portal_option_values: boolean,
}

const state = {
  id: null,
  node_name: '',
  node_properties: [],
  portal_id: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'node_name' },
  { key: 'portal_id' },
  { key: 'title' },
]

export default state
